module.exports = __webpack_public_path__ + "img/ressource-01.a24cbf77.svg";